import createAction from '../../common/services/create-action';

export const ADD_ITEM_TO_UPLOADED_REGISTRY = 'ADD_ITEM_TO_UPLOADED_REGISTRY';
export const REMOVE_ITEM_FROM_UPLOADED_REGISTRY = 'REMOVE_ITEM_FROM_UPLOADED_REGISTRY';

export const addItemToUploadedRegistry = createAction(ADD_ITEM_TO_UPLOADED_REGISTRY);
export const removeItemFromUploadedRegistry = createAction(REMOVE_ITEM_FROM_UPLOADED_REGISTRY);
